import * as React from 'react';
import clsx from 'clsx';
import { Icon, Spinner, Typography } from '../common';
import Icons from '@/const/icons';
import { Subjects } from '@/interfaces/inbox';

interface LisQuestionOptionsComponentProps {
	questionsSubjects: Subjects[];
	setQuestion: (value: Subjects) => void;
}

export const ListQuestionOptionsComponent: React.FC<
	LisQuestionOptionsComponentProps
> = ({ questionsSubjects, setQuestion }) => {
	return (
		<div className="lg:w-[656px]">
			<ul>
				{questionsSubjects.length > 0 ? (
					questionsSubjects.map((question, index) => (
						<li
							key={'case-inquire-' + index}
							className={clsx(
								'border border-transparent',
								'flex items-center gap-x-2 bg-grey-5 px-4 py-3 rounded-xl mb-3 text-left cursor-pointer',
								'hover:border-green-base active:border-none',
								'active:bg-green-secondary focus:bg-green-secondary'
							)}
							onClick={() => setQuestion(question)}
						>
							<span className="w-4 h-4">
								<Icon
									src={Icons.sms}
									className="!size-4 text-[#C0D653]"
									width={16}
								/>
							</span>
							<Typography type="regular-16">{question.title}</Typography>
						</li>
					))
				) : (
					<div className="flex justify-center items-center w-full h-full my-10">
						<Spinner type="loadingPage" />
					</div>
				)}
			</ul>
		</div>
	);
};
